import {
    IAppointment,
    IAppointmentSlot,
    IAppointmentSecurityDay,
} from "@/models";

interface ISecurityState {
    securityDay: IAppointmentSecurityDay;
    selectedAppointment: IAppointment;
}

const initialState: ISecurityState = {
    securityDay: null,
    selectedAppointment: null,
};

export { ISecurityState, initialState };
